import useSWR from "swr";
import type { SwrReturnType } from "~/models/Api";
import type { DealEstimationOcrRequest } from "~/models/DealEstimationOcrRequest";
import { generatePath } from "~/utils/generatePath";

const POLLING_INTERVAL_MS = 3_000;
const STOPPED_INTERVAL_MS = 0;

export const getRefreshInterval = (
	data: DealEstimationOcrRequest | undefined
): number =>
	data === undefined || data.status === "processing"
		? POLLING_INTERVAL_MS
		: STOPPED_INTERVAL_MS;

export const useDealEstimationOcrRequest = (
	dealId: number,
	id: number,
	shouldPoll = false
): SwrReturnType<DealEstimationOcrRequest> => {
	const key = generatePath("/deals/:deal_id/deal_estimation_ocr_requests/:id", {
		deal_id: dealId,
		id
	});
	const { data, mutate, isLoading, error } = useSWR<DealEstimationOcrRequest>(
		key,
		{
			refreshInterval: shouldPoll ? getRefreshInterval : STOPPED_INTERVAL_MS
		}
	);
	return {
		data: data ?? null,
		error,
		isLoading,
		mutate
	};
};
